module.exports = __webpack_public_path__ + "img/geodir-mtc-logo.c1cab00f.png";